// Dependencies
import { camelCase, snakeCase, isObject } from 'lodash'

export class ConvertUtility {

  static key(input, pattern = 'camel') {
    
    // Default Result
    let result = input
    
    // Array Validator
    const isArray = Array.isArray(input)

    // Validate Object
    if (typeof input !== 'object' && !isArray) return input

    // Ignore Date
    if (input instanceof Date) return input

    // Key Mutator
    const maker = (key, pattern) => {
      if (pattern == 'camel') key = camelCase(key)
      if (pattern == 'snake') key = snakeCase(key)
      return key
    }

    // Key Mapper
    const mapper = (data, key) => {

      // Mapping Result
      const result = { ...data }

      // Set Key
      const mapKey = maker(key, pattern)
      
      // Set Value 
      const mapValue = ConvertUtility.key(
        (input)[key], pattern
      )

      // Mapping Key & Value
      result[mapKey] = mapValue

      // Mapping Data
      return result
    }

    // Validate Array
    if (isArray) {

      // Mutate Array
      result = input.map(
        (item) => ConvertUtility.key(item, pattern)
      )
    }
    else if (isObject(input)) {
      
      // Mutate Object
      result = Object
        .keys(input)
        .reduce(mapper, {})
    }

    return result
  }
}


// WEBPACK FOOTER //
// ./src/clients/utils/convert-utility.js